import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface WellnessEducation {
  id: string;
  tool_name: string;
  category: string;
  short_description: string;
  why_it_matters: string;
  research_summary: string;
  how_to_optimize?: string;
  research_links: any; // JSONB from database
  tags: string[];
  is_published: boolean;
}

export function useWellnessEducation(toolName: string, category?: string) {
  return useQuery({
    queryKey: ['wellness-education', toolName, category],
    queryFn: async () => {
      let query = supabase
        .from('wellness_education')
        .select('*')
        .eq('tool_name', toolName)
        .eq('is_published', true);

      if (category) {
        query = query.eq('category', category);
      }

      const { data, error } = await query.maybeSingle();

      if (error && error.code !== 'PGRST116') throw error;
      return data as WellnessEducation | null;
    },
  });
}
